module.exports = __webpack_public_path__ + "yz/img/唯品会.e1909e19.jpg";